import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);

// Fade out the static SSR hero once React has painted, then remove it.
// This eliminates any flash between the hand-written HTML and the React tree.
const ssr = document.getElementById("ssr-hero");
if (ssr) {
  // Wait two frames so the React hero has had a chance to paint underneath.
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      ssr.classList.add("is-hydrated");
      setTimeout(() => ssr.remove(), 400);
    });
  });
}
